import type { FunctionComponent, HTMLProps, ReactNode } from 'react'
import React from 'react'

import classnames from 'classnames'

import type { LinkAppearance } from '../../../types'
import styles from './BaseLink.module.scss'

export const BaseLink: FunctionComponent<Props> = ({
  children,
  href,
  invertedUnderline = false,
  includeAnimation = true,
  className,
  appearance,
  ...rest
}) => {
  const props = {
    className: classnames(
      styles.base,
      {
        [styles.baseIncludeAnimation]: includeAnimation,
        [styles.baseIncludeAnimationInverted]:
          includeAnimation && invertedUnderline,
        [styles.baseIncludeAnimationPrimary]:
          includeAnimation && appearance === 'primary',
      },
      className
    ),
    'data-testid': 'base-link',
    ...rest,
  }

  const nonNullHref = href ?? ''

  return (
    <>
      <a href={nonNullHref} {...props}>
        {children}
      </a>
    </>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  href?: string | null
  invertedUnderline?: boolean
  includeAnimation?: boolean
  className?: string
  appearance?: LinkAppearance
  children: ReactNode
  [key: `data-${string}`]: string | undefined
} & HTMLProps<HTMLAnchorElement>
